import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { StorageService } from '@shared/services/storage.service';
import { GLOBAL_DATA } from '@shared/constants';
import { MealData } from '@shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  shopId!: string;
  tableId!: string;

  constructor(private router: Router, public localStorage: StorageService) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    this.shopId = route.paramMap.get('shopId') as string;
    this.tableId = route.queryParamMap.get('table') as string;
    const datas = this.localStorage.getLocalStorageItem<MealData>(GLOBAL_DATA);

    if (!datas?.shopId && !datas?.tableId) {
      // 404 error url not found
      this.router.navigate([`error/404`]);
    }
    return true;
  }
}
